import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useResource } from 'app/common/api';
import { TPageable } from 'app/common/constraints/core/constraints';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';

import { TTrainType } from '../../core/train-types';
import { TTrainTypesConstraints } from '../../core/train-types-constraints';
import { getTrainTypesRequest } from '../../requests/get-train-types.request';
import { TrainTypesSelect } from '../../ui/train-types-select/train-types-select';

type SelectValue = { id: number } | null;

type AvailableTrainTypesSelectProps = {
  value?: SelectValue;
  onChange?: (trainType: SelectValue) => void;
};

export const AvailableTrainTypesSelect = observer(
  ({ value, onChange }: AvailableTrainTypesSelectProps) => {
    const [trainTypes, setTrainTypes] = useState<TTrainType[]>([]);
    const errorNotify = usePageNotify();

    const getTrainTypesResource = useResource<
      TTrainTypesConstraints,
      TPageable<TTrainType[]>
    >({
      request: getTrainTypesRequest,
      errorNotify: errorNotify,
      onDone(result) {
        setTrainTypes(result.content);
      },
    });

    const innerValue = getTrainTypesResource.isLoading ? undefined : value;

    const handleChange = (values: SelectValue) => {
      onChange && onChange(values);
    };

    const isLoading = getTrainTypesResource.isLoading;

    useEffect(() => {
      getTrainTypesResource.send({ filter: null, sorting: [] });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <TrainTypesSelect
        allowClear
        loading={isLoading}
        trainTypes={trainTypes}
        value={innerValue}
        onChange={handleChange}
      />
    );
  },
);
